import React from 'react';

export function Spinner() {
    return (
        <div className="spinner-wrapper">
            <i className="fa fa-spinner fa-pulse fa-3x fa-fw" />
        </div>
    );
}
